import { clearAuth } from "./auth";
import { disconnectRealtime } from "../realtime/socket";

// Single source of truth for signing out. A hard navigation (not SPA navigate)
// is intentional: it tears down the realtime socket and drops the entire
// in-memory Redux / RTK Query cache, so a second user on a shared browser can
// never see the previous user's cached messages, orders, or profile.
export function performLogout(redirectTo = "/login"): void {
  disconnectRealtime();
  clearAuth();
  window.location.assign(redirectTo);
}
